var map = {
	"./decidim/avatar-multiuser.png": 52973,
	"./decidim/brands/facebook.svg": 25497,
	"./decidim/brands/google.svg": 27984,
	"./decidim/brands/twitter-x.svg": 62053,
	"./decidim/cc-badge.png": 57211,
	"./decidim/decidim-logo.svg": 15215,
	"./decidim/default-avatar.svg": 32035,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 46537,
	"./decidim/icons.svg": 2802,
	"./decidim/pattern.png": 20945,
	"./decidim/placeholder-card-g.svg": 34622,
	"./decidim/placeholder-card-l.svg": 31221,
	"./decidim/placeholder.jpg": 31684,
	"./decidim/remixicon.symbol.svg": 54278,
	"./decidim/vendor/social-share-button/douban.svg": 74761,
	"./decidim/vendor/social-share-button/email.svg": 14922,
	"./decidim/vendor/social-share-button/facebook.svg": 60450,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 47598,
	"./decidim/vendor/social-share-button/hacker_news.svg": 78186,
	"./decidim/vendor/social-share-button/linkedin.svg": 42680,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 82737,
	"./decidim/vendor/social-share-button/pinterest.svg": 90356,
	"./decidim/vendor/social-share-button/reddit.svg": 40910,
	"./decidim/vendor/social-share-button/telegram.svg": 82095,
	"./decidim/vendor/social-share-button/tumblr.svg": 93900,
	"./decidim/vendor/social-share-button/twitter.svg": 93055,
	"./decidim/vendor/social-share-button/vkontakte.svg": 75741,
	"./decidim/vendor/social-share-button/wechat.svg": 47584,
	"./decidim/vendor/social-share-button/whatsapp.svg": 97824,
	"./decidim/vendor/social-share-button/x.svg": 65578,
	"./decidim/vendor/social-share-button/xing.svg": 92862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84422;